import { provideAppInitializer } from '@angular/core';

import { THEME_NAMES, THEME_PREFIX } from './app.config.base';

const THEME_STORAGE_KEY = `${THEME_PREFIX}-theme`;

export const provideThemeStorageGuard = () =>
  provideAppInitializer(() => {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored !== null && !(THEME_NAMES as readonly string[]).includes(stored)) {
      localStorage.removeItem(THEME_STORAGE_KEY);
    }
  });
